import { bool } from "prop-types";
import { observer } from "mobx-react";
import {
  TimelineSectionSettings,
  useEstimateEditorSettings,
  useEstimateEditorStore,
  useEstimateStructure, useEstimateTableSettings,
  useVisibilityModeCellClassName,
  VisibilityButton
} from "@tools";
import { Collapse, IconButton } from "@material-ui/core";
import { Drawer } from "@assets";
import { TimelineSectionsRow } from "../../TimelineSections/TimelineSectionsRow";
import { TimelineSectionsRowGroupList } from "../../TimelineSections/TimelineSectionsRowGroupList";
import { TimelineMenuTitle } from "../components/TimelineMenuTitle";

export const TimelineSections = observer(({ isFirst }) => {
  const structure = useEstimateStructure();
  const { visibilityMode } = useEstimateEditorStore();
  const { blockExpansions, allowEdition } = useEstimateEditorSettings();
  const { fullSectionActions, setFullSectionActions } = useEstimateTableSettings();

  const { settings, visibility } = structure;
  const { expandTimelineSections } = settings;
  const { hideTimelineSections } = visibility;

  const sections = structure.currentTimeline?.visibleSections || [];

  const className = useVisibilityModeCellClassName(hideTimelineSections);

  const handleTimelineSectionsVisibility = () => {
    if (blockExpansions) return;
    settings.setExpandTimelineSections(!expandTimelineSections);
    if(expandTimelineSections)
      setFullSectionActions(false);
  };

  return (
    <>
      <TimelineMenuTitle
        code="sections"
        isFirst={isFirst}
        expandable
        expanded={expandTimelineSections}
        onExpand={handleTimelineSectionsVisibility}
        className={className}
        actions={
        allowEdition && expandTimelineSections &&
          <IconButton
            size="small"
            color="primary"
            tabIndex={-1}
            onClick={() => setFullSectionActions(!fullSectionActions)}
          >
            <Drawer />
          </IconButton>
        }
      >
        {
          allowEdition &&
          <TimelineSectionSettings />
        }
        {
          visibilityMode &&
          <VisibilityButton
            hidden={hideTimelineSections}
            onChange={visibility.setHideTimelineSections}
          />
        }
      </TimelineMenuTitle>
      <Collapse
        in={expandTimelineSections}
        timeout="auto"
        mountOnEnter
        unmountOnExit
        className={className}
      >
        <TimelineSectionsRowGroupList
          listElements={sections}
          onReorder={structure.currentTimeline.reorderSections}
          disabled={!allowEdition}
          group="sections"
        >
          {
            sections.map((section, index) => (
              <TimelineSectionsRow
                key={section.id}
                section={section}
                index={index}
              />
            ))
          }
        </TimelineSectionsRowGroupList>
      </Collapse>
    </>
  );
});

TimelineSections.propTypes = {
  isFirst: bool,
};
